module.exports = ".container-fluid {\n  margin-top: 120px;\n  background-color: #f5f8fa; }\n  .container-fluid img {\n    max-height: 100%;\n    max-width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/reports.component.scss
// module id = ./src/app/reports/reports.component.scss
// module chunks = main